import { useState } from 'react';
import { TasteSetupCards } from '../components/TasteSetupCards';

/**
 * PUBLIC, shareable visual mockup of the First-Plan Taste Setup swipe/tap deck,
 * rendered in a phone-sized frame using the REAL Fitxess catalog snapshot.
 * Records NOTHING (demoMode) — purely to preview how the swipe feels.
 */
export default function TasteSetupDemo() {
  var [done, setDone] = useState(false);
  var [runKey, setRunKey] = useState(0);

  function restart() {
    setDone(false);
    setRunKey(runKey + 1);
  }

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center bg-muted/40 px-4 py-8"
      data-testid="taste-setup-demo-page"
    >
      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-3">
        First-Plan Taste Setup · live mockup (real recipes)
      </p>
      <div className="w-full max-w-[400px] rounded-3xl bg-background shadow-xl border border-border/40 p-5">
        {done ? (
          <div className="py-14 text-center space-y-4" data-testid="taste-setup-demo-done">
            <p className="font-heading font-bold text-lg">That's the whole deck!</p>
            <p className="text-sm text-muted-foreground">
              In the real app this flows straight into planning. Nothing was saved in this demo.
            </p>
            <button
              onClick={restart}
              className="px-5 py-2.5 rounded-full bg-accent text-accent-foreground font-medium hover:opacity-90 transition-opacity"
              data-testid="taste-setup-demo-restart"
            >
              Run it again
            </button>
          </div>
        ) : (
          <TasteSetupCards
            key={runKey}
            demoMode
            onComplete={function () { setDone(true); }}
          />
        )}
      </div>
    </div>
  );
}
